import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { FixtureProfile, FixtureProfileResponse } from "~types/fixtureProfile";

const useFetchDefaultFixtureProfile = () => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  return useQuery<FixtureProfile>({
    queryKey: ["defaultFixtureProfiles", sport, organizationId],
    queryFn: () =>
      request<FixtureProfileResponse>(`${sport}/o/${organizationId}/fixtureProfiles?defaultProfile=true`).then((response) => {
        return response?.data?.[0];
      }),
  });
};

export default useFetchDefaultFixtureProfile;
